import React from "react";
import { formatInTimeZone } from "date-fns-tz";
import { Link } from "react-router-dom";
import { withStyles } from "@mui/styles";
import ChatBubble from "@mui/icons-material/ChatBubble";

const styles = (theme) => ({
  event: {
    width: "100%",
    backgroundColor: "#fff",
    padding: 15,
    borderBottom: "1px solid #e6e5e5",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  title: {
    color: "#000000",
    fontSize: "18px",
    lineHeight: "21px",
  },
  contentWrapper: {
    display: "flex",
    alignItems: "center",
    gap: "15px",
    flex: 1,
  },
  messageBadge: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#2CB045",
    borderRadius: "50%",
    width: "40px",
    height: "40px",
    flexShrink: 0,
  },
  messageBadgeIcon: {
    color: "#fff",
    fontSize: "20px",
  },
  badgeCount: {
    position: "absolute",
    top: "-5px",
    right: "-5px",
    backgroundColor: "#FF3B30",
    borderRadius: "50%",
    width: "22px",
    height: "22px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "12px",
    fontWeight: "bold",
    color: "#fff",
  },
});

function Event({ classes, event, actionButton, to, borderColor, unreadMessageCount }) {
  return (
    <div
      className={classes.event}
      style={{ borderLeft: `5px solid ${borderColor}` }}
    >
      <Link to={to} style={{ display: "flex", alignItems: "center", flex: 1, textDecoration: "none" }}>
        <div className={classes.contentWrapper}>
          {unreadMessageCount > 0 && (
            <div style={{ position: "relative" }}>
              <div className={classes.messageBadge}>
                <ChatBubble className={classes.messageBadgeIcon} />
              </div>
              <div className={classes.badgeCount}>{unreadMessageCount}</div>
            </div>
          )}
          <div>
            {event.name && <div className={classes.title}>{event.name}</div>}
            {event.eventDate && (
              <div className={classes.title}>
                {formatInTimeZone(event.eventDate, "UTC", "do MMMM yyyy")}
              </div>
            )}
          </div>
        </div>
      </Link>
      {actionButton}
    </div>
  );
}

export default withStyles(styles)(Event);
